import { useEffect, useState } from 'react';

import { supabase } from '../api/supabase-client';

/**
 * Пока в профиле нет имени, узнаём человека по логину из Supabase.
 * Имя появится вместе с `full_name` — план в docs/project/roles-and-access.md.
 */
export function useSignedInEmail(): string | null {
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    supabase.auth
      .getUser()
      .then(({ data }) => {
        if (!cancelled) setEmail(data.user?.email ?? null);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  return email;
}

/**
 * Имя человека — до собачки: и у служебных адресов
 * (`qa-headlines@instafarm.internal`), и у настоящих почт. Полный адрес
 * показываем отдельной строкой, поэтому домен здесь только мешает.
 */
export function loginOf(email: string): string {
  return email.split('@')[0] || email;
}

/** Две буквы для кружка аватарки. */
export function initialsOf(value: string): string {
  return value.slice(0, 2).toUpperCase();
}
